module.exports = __webpack_public_path__ + "static/media/no_kpi_available.44650558.svg";